import Component from "../../lib/component";
import {injectStylesheet} from "../../helpers/injection";

export const MessagebarConfig = {
    componentTypeKey: 'Messagebar',

    baseHtmlClass: 'messagebar',
    selector: '.messagebar',

    datasetConfigKey: 'messagebar_config',

    linerSelector: '.messagebar__liner',

    discardTimeout: 5000,
};

export class Messagebar extends Component {

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: MessagebarConfig
        });

        this.setDatasetConfig(MessagebarConfig.datasetConfigKey);
        this.stylesheetPath = this.getDatasetConfigValue('stylesheet_path');

        this.linerElement = this.element.querySelector(MessagebarConfig.linerSelector);

        if (this.isActive()) {
            setTimeout(this.handleDiscardTimeout.bind(this), MessagebarConfig.discardTimeout);
        }

        // Render the initial state after we load any style sheets…
        if (this.stylesheetPath) {
            injectStylesheet(this.stylesheetPath, () => {
                this.addHtmlClassState('inited');
                this.render();
            });
        } else {
            this.addHtmlClassState('inited');
            this.render();
        }

    }

    handleDiscardTimeout() {
        this.discarded = true;
        this.render();
    }

    render() {
        this.conditionallySetHtmlClassState(this.discarded, 'discarded');
        this.swapHtmlClassStates(this.isActive(), 'active', 'inactive');
    }

    isActive() {
        return this.linerElement.childElementCount > 0;
    }
}